import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { useContentActions } from 'content-management-actions-lib/providers/ContentActionsProvider';
import { ContentObjectTypes, contentHasTranslations, getAssociatedContentTranslations, useContentObjectType } from 'content-management-data-lib';
import { registerMutation, useMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { PAGE_ACTION_IDS } from '../../constants/actionIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MoveSubcategoryMutation = registerMutation({
  fieldName: 'moveSubcategory',
  args: ['pageId', 'contentObjectType'],
  fetcher: ({
    pageId,
    contentObjectType
  }) => http.put(`page-management/v1/${contentObjectType === ContentObjectTypes.LANDING_PAGE ? 'landing-pages' : 'site-pages'}/${pageId}/subcategory-move`)
});
const MoveSubcategoryModal = ({
  crmObjects: [crmObject],
  onClose
}) => {
  const {
    contentObjectType
  } = useContentObjectType();
  const {
    onActionError,
    onActionSuccess
  } = useContentActions();
  const [moveSubcategory, {
    loading
  }] = useMutation(MoveSubcategoryMutation);
  const handleMoveSubcategory = () => {
    const pageId = crmObject.objectId;
    moveSubcategory({
      variables: {
        pageId,
        contentObjectType
      }
    }).then(updatedContentObjectResponse => {
      var _updatedContentObject;
      const updatedContentObject = (_updatedContentObject = updatedContentObjectResponse.data) === null || _updatedContentObject === void 0 ? void 0 : _updatedContentObject.moveSubcategory;
      onActionSuccess({
        actionId: PAGE_ACTION_IDS.MOVE_SUBCATEGORY,
        data: {
          completedResults: updatedContentObject ? [updatedContentObject] : []
        }
      });
      onClose();
    }).catch(error => {
      onActionError({
        actionId: PAGE_ACTION_IDS.MOVE_SUBCATEGORY,
        error,
        data: {
          failedResults: [crmObject]
        }
      });
    });
  };
  const baseLangKey = `page-lib.actionModals.moveSubcategory.${contentObjectType}`;
  const isSingleMlangGroup = contentHasTranslations(crmObject);
  const bodyMessageKey = isSingleMlangGroup ? `${baseLangKey}.bodyWithTranslations` : `${baseLangKey}.body`;
  const bodyOptions = isSingleMlangGroup ? {
    count: getAssociatedContentTranslations(crmObject).length
  } : {
    count: 1
  };
  return /*#__PURE__*/_jsxs(Modal, {
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose,
      color: "icon-primary-disabled"
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${baseLangKey}.header`
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: bodyMessageKey,
        options: bodyOptions
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        "data-test-id": "modal-confirm",
        onClick: handleMoveSubcategory,
        loading: loading,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${baseLangKey}.confirm`
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "modal-cancel",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${baseLangKey}.cancel`
        })
      })]
    })]
  });
};
export default MoveSubcategoryModal;